import { SIZE_MAP } from '@flex-design-system/stitches-react';
import { getImageSrcSet } from '@flex-services/file/base';
import { resizeImage } from '@flexteam/utils';

const getNumberSize = (rawSize = "default") => {
  return typeof rawSize === "string" ? SIZE_MAP[rawSize] : rawSize;
};
function decideAvatarSource(params) {
  const {
    profileImageUrl,
    profileImageFileKey,
    size: rawSize = "default"
  } = params;
  const size = getNumberSize(rawSize);
  if (typeof profileImageFileKey === "string") {
    return getImageSrcSet({
      fileKey: profileImageFileKey,
      size
    });
  }
  if (typeof profileImageUrl === "string") {
    return {
      src: profileImageUrl,
      srcSet: void 0
    };
  }
  return { src: void 0, srcSet: void 0 };
}
async function resizeProfileImageSrc(params) {
  const { src, size: rawSize = "default" } = params;
  const size = getNumberSize(rawSize);
  const resizeImageResult = await resizeImage({
    src,
    width: size,
    height: size
  });
  return resizeImageResult.value;
}

export { decideAvatarSource, resizeProfileImageSrc };
//# sourceMappingURL=utils.mjs.map
